import React, { useEffect } from 'react'
import ReactTooltip from 'react-tooltip'
import CustomLabel from '../CustomLabel'
import PassField from './components/PassField'
import { useSelector } from 'react-redux'

const PASSWORD_TOOLTIP_ID = 'tip'

const PasswordFieldC = ({
  formik,
  name,
  label,
  placeholder,
  fieldClassName,
  extraLabel,
  isAccountInfo,
  containerClassName,
  regFields = '',
  showStar,
  showInfoIcon = false,
  autoComplete = 'off',
  showLabel = true
}) => {
  const { languageData } = useSelector((state) => state.language)
  const passwordTip = languageData?.passwordTip ?? ''
  const showPasswordTooltip = name === 'password' && showInfoIcon

  useEffect(() => {
    if (showPasswordTooltip) {
      ReactTooltip.rebuild()
    }
  }, [showPasswordTooltip, passwordTip])

  return (
    <>
      {(regFields ? regFields?.password !== 0 : true) && (
        <div className={`${containerClassName} icon_include password-info`}>
          {showLabel &&
            <CustomLabel
              name={name}
              label={label}
              extraLabel={extraLabel}
              regFields={regFields}
              showStar={showStar}
              className='custom-label'
            />}

          {showPasswordTooltip && (
            <>
              <span
                className='custom-tooltip-icon'
                data-for={PASSWORD_TOOLTIP_ID}
                data-tip={passwordTip}
              >
                i
              </span>
              <ReactTooltip
                id={PASSWORD_TOOLTIP_ID}
                place='top'
                type='info'
                effect='float'
                multiline
              />
            </>
          )}
          <PassField
            name={name}
            fieldClassName={fieldClassName}
            placeholder={placeholder}
            formik={formik}
            isAccountInfo={isAccountInfo}
            showInfoIcon={showInfoIcon}
            autoComplete={autoComplete}
          />

        </div>
      )}
    </>
  )
}

export default PasswordFieldC
